import { Pipe, PipeTransform } from '@angular/core';

import _ from 'lodash';

@Pipe({
	name: 'phone',
	standalone: true,
})
export class PhonePipe implements PipeTransform {
	transform(value: string | number, countryId?: number): string {
		if (!value) {
			return '';
		}

		const phone = String(value);

		if (phone.match(/[a-z]/i)) {
			return phone;
		}

		const splitPhone = phone
			.replace(/[-\.\(\)]/g, '')
			.replace(/ /g, '')
			.split('');

		// 3454 040506
		if (countryId === 229) {
			if (splitPhone.length > 10) return phone;
			return `${_.slice(splitPhone, 0, 4).join('')} ${_.slice(splitPhone, 4, 10).join('')}`;
		}

		// (333) 444-5555
		if (splitPhone.length > 10) return phone;
		return `(${_.slice(splitPhone, 0, 3).join('')}) ${_.slice(splitPhone, 3, 6).join('')}-${_.slice(splitPhone, 6, 10).join('')}`;
	}
}
